import { formatDate } from '../../lib/utils';

interface ReportHeaderProps {
  inspectionId: string;
  createdAt: string;
  className?: string;
}

export const ReportHeader = ({
  inspectionId,
  createdAt,
  className,
}: ReportHeaderProps) => {
  return (
    <div className={className}>
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <span className="text-brand-600">TreadAI</span>
            <span className="text-gray-300">|</span>
            <span className="text-xl font-normal text-gray-600">
              Tire Inspection Report
            </span>
          </h1>
          <p className="text-sm text-gray-500 mt-2">
            Inspection ID: {inspectionId}
          </p>
        </div>
        <div className="text-right">
          <div className="text-sm text-gray-600">Report Date</div>
          <div className="text-sm font-semibold text-gray-900 mt-1">
            {formatDate(createdAt)}
          </div>
        </div>
      </div>

      <div className="border-t-2 border-brand-600 mb-6" />
    </div>
  );
};
